export enum ThemeEnum {
    InterviewV2 = 'interviewV2',
    Legacy = 'legacy'
}
